import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-yonghu",
  "use": "icon-yonghu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-yonghu\"><defs><style type=\"text/css\"></style></defs><path d=\"M256 256a256 256 0 1 0 512 0 256 256 0 1 0-512 0zM733.769143 987.428571H290.230857A217.039238 217.039238 0 0 1 73.142857 770.340571v-4.681142a217.039238 217.039238 0 0 1 217.088-217.088h443.538286A217.039238 217.039238 0 0 1 950.857143 765.659429v4.681142a217.039238 217.039238 0 0 1-217.088 217.088z\" fill=\"#3076F0\" p-id=\"899\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol